function compare(key: string | number, type = 'up') {
  return function sortGen(m: { [x: string]: any }, n: { [x: string]: any }) {
    const a = isNaN(Number(m[key])) ? m[key]?.toUpperCase() : Number(m[key]);
    const b = isNaN(Number(n[key])) ? n[key]?.toUpperCase() : Number(n[key]);

    if (a < b) {
      return type === 'up' ? -1 : 1;
    }
    if (a > b) {
      return type === 'up' ? 1 : -1;
    }
    return 0;
  };
}

export function sortDown(list: any[], key: string | number) {
  const tempList = list.slice();
  return tempList.sort(compare(key, 'down'));
}

export function sortUp(list: any[], key: string | number) {
  const tempList = list.slice();
  return tempList.sort(compare(key, 'up'));
}
